
import { Image } from "element-ui"
import { formatImgUrl } from "../../utils/utils"

export default {
  name: "HorizontalMiniIconMenu",
  components: {
    [Image.name]: Image
  },
  props: {
    dataList: {
      type: Array,
      default: () => [
        // {
        //   remark: "我是一個標題",
        //   spImgUrl: "https://img.dmallcdn.com/20230331/734aea64-2b06-43f8-a2dd-71d8cfeadfe5"
        // },
      ]
    }
  },
  methods: {
    formatImgUrl,
    formatLinkTo(item) {
      if (item.itemType === 15) {
        return {
          path: "/banner_home",
          query: {
            storeId: item.storeId
          }
        }
      }
      return item.resource
    }
  }
}
